import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import cn from "../../../utils/cn";
const TableHeader = React.forwardRef(({ className, ...props }, ref) => (_jsx("thead", { ref: ref, className: cn(className), ...props })));
TableHeader.displayName = "TableHeader";
export default memo(TableHeader);
